import React from 'react';
import { Tooltip } from 'styleguide';

import { ValueBox as CraftUiValueBox, ValueGroup as CraftUiValueGroup } from '@candu-ai/craft/ui';
import {
  InputField,
  Section,
  Toggle,
  ValidationErrorMessages,
  ValueBox,
  ValueGroup,
} from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';
import { People, Profile } from 'craft/icons';

import { TraitSelect } from './TraitSelect';

interface Props {
  nodeIds: string[];
}

export const CheckListGroupSettings = ({ nodeIds }: Props) => {
  const {
    props,
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  const { scope, scopeTrait } = props;

  const selectTrait = (trait: string) => {
    setProps({ scopeTrait: trait });
  };

  return (
    <>
      <Section name="CheckList Settings">
        <CraftUiValueGroup label="Title">
          <CraftUiValueBox>
            <InputField
              nodeIds={nodeIds}
              value={props.title.value}
              name="title"
              onChange={(e) => setProps({ title: e.target.value })}
            />
          </CraftUiValueBox>
        </CraftUiValueGroup>
        <ValueGroup>
          <ValueBox dark label="Progress">
            <Tooltip content="Per User" position="top" showDelay={500}>
              <Toggle
                toggleGroup="checklist-scope"
                id="user"
                onClick={() => setProps({ scope: 'user' })}
                isActive={scope.value === 'user'}
                icon={Profile}
              />
            </Tooltip>
            <Tooltip content="Per Group" position="top" showDelay={500}>
              <Toggle
                toggleGroup="checklist-scope"
                id="account"
                onClick={() => setProps({ scope: 'account' })}
                isActive={scope.value === 'account'}
                icon={People}
              />
            </Tooltip>
          </ValueBox>
        </ValueGroup>
        <ValidationErrorMessages nodeIds={nodeIds} />
        {scope.value === 'account' && (
          <ValueGroup>
            <TraitSelect value={scopeTrait.value} onChange={selectTrait} label="Group By" />
          </ValueGroup>
        )}
      </Section>
    </>
  );
};
